export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Latin1-baf06bf0fab0f2a87c44706c677de10e.woff2";